/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from './components/FeatherIcon.vue'
import ShipbluIcon  from './layouts/components/ShipbluIcon.vue'
import ShipbluButton  from './layouts/components/ShipbluButton.vue'
import ShipbluInput  from './layouts/components/ShipbluInput.vue'
import ShipbluSelect  from './layouts/components/ShipbluSelect.vue'
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue'
import PageHeader from './layouts/components/PageHeader.vue'

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(ShipbluInput.name, ShipbluInput)
Vue.component(ShipbluIcon.name, ShipbluIcon)
Vue.component(ShipbluButton.name, ShipbluButton)
Vue.component(ShipbluSelect.name, ShipbluSelect)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component(PageHeader.name, PageHeader)


// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    })
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    })
  }
})

Vue.component(vSelect)
